import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "width", "widthAdaptive", "children", "focused", "placeholder", "startIcon", "endIcon", "empty", "size", "onClear", "allowClear", "right", "disabled", "bottom", "innerButton", "onClick", "readOnly", "extraRight"];
import classNames from '@jd/jmtd-tools/es/classnames';
import PropTypes from 'prop-types';
import React, { cloneElement } from 'react';
import Button from '../Button';
import ConfigConsumer from '../ConfigConsumer';
import Icon from '../Icon';
import Label from '../Label';
export default function BaseInput(_ref) {
  var className = _ref.className,
      width = _ref.width,
      widthAdaptive = _ref.widthAdaptive,
      children = _ref.children,
      focused = _ref.focused,
      placeholder = _ref.placeholder,
      startIcon = _ref.startIcon,
      endIcon = _ref.endIcon,
      empty = _ref.empty,
      size = _ref.size,
      onClear = _ref.onClear,
      allowClear = _ref.allowClear,
      right = _ref.right,
      disabled = _ref.disabled,
      bottom = _ref.bottom,
      innerButton = _ref.innerButton,
      _onClick = _ref.onClick,
      readOnly = _ref.readOnly,
      extraRight = _ref.extraRight,
      other = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(ConfigConsumer, {
    size: size
  }, function (_ref2) {
    var configSize = _ref2.size;
    var main = /*#__PURE__*/React.createElement(React.Fragment, null, startIcon && /*#__PURE__*/React.createElement("div", {
      className: "jmtd-base-input-start-icon"
    }, startIcon), /*#__PURE__*/React.createElement("div", {
      className: "jmtd-base-input-content"
    }, empty && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "jmtd-base-input-placeholder-wrapper"
    }, /*#__PURE__*/React.createElement(Label, {
      className: "jmtd-base-input-placeholder",
      theme: "light"
    }, placeholder))), children), (extraRight || right || allowClear || endIcon || innerButton) && /*#__PURE__*/React.createElement("div", {
      className: "jmtd-base-input-content-right"
    }, right, (allowClear || endIcon) && /*#__PURE__*/React.createElement("div", {
      className: "jmtd-base-input-end-icon"
    }, /*#__PURE__*/React.createElement("span", {
      className: "jmtd-base-input-icon-clear"
    }, allowClear && /*#__PURE__*/React.createElement(Button, {
      startIcon: /*#__PURE__*/React.createElement(Icon, {
        className: "jmti-close-circle"
      }),
      link: true,
      dense: true,
      onClick: onClear
    })), /*#__PURE__*/React.createElement("span", {
      className: "jmtd-base-input-icon-normal"
    }, endIcon !== null && endIcon !== void 0 ? endIcon : /*#__PURE__*/React.createElement(Icon, {
      className: "jmtd-base-input-icon-placeholder jmti-close-circle"
    }))), innerButton && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "jmtd-base-input-inner-button-separator"
    }, "|"), /*#__PURE__*/cloneElement(innerButton, {
      link: true,
      disabled: empty,
      dense: true,
      semantic: 'primary'
    })), extraRight));
    return /*#__PURE__*/React.createElement("div", _extends({
      className: classNames('jmtd-base-input', 'jmtd-button-like', className, {
        'jmtd-base-input-with-inner-button': !!innerButton,
        'jmtd-base-input-allow-clear': allowClear,
        'jmtd-base-input-mini': configSize === 'mini',
        'jmtd-base-input-small': configSize === 'small',
        'jmtd-base-input-large': configSize === 'large',
        'jmtd-base-input-with-start-icon': startIcon,
        'jmtd-base-input-with-end-icon': endIcon,
        'jmtd-base-input-disabled': disabled,
        'jmtd-base-input-focused': focused,
        'jmtd-base-input-empty': empty,
        'jmtd-base-input-read-only': readOnly
      }),
      style: _defineProperty({}, widthAdaptive ? 'minWidth' : 'width', width),
      onClick: function onClick(e) {
        if (!disabled) {
          _onClick(e);
        }
      }
    }, other), /*#__PURE__*/React.createElement("div", {
      className: "jmtd-base-input-top"
    }, main), bottom, disabled && /*#__PURE__*/React.createElement("div", {
      className: "jmtd-base-input-disabled-wall"
    }));
  });
}
BaseInput.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  focused: PropTypes.bool,
  placeholder: PropTypes.node,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  widthAdaptive: PropTypes.bool,
  startIcon: PropTypes.node,
  endIcon: PropTypes.node,
  empty: PropTypes.bool,
  size: PropTypes.oneOf(['mini', 'small', 'middle', 'large']),
  onClear: PropTypes.func,
  allowClear: PropTypes.bool,
  right: PropTypes.node,
  disabled: PropTypes.bool,
  bottom: PropTypes.node,
  innerButton: PropTypes.node,
  onClick: PropTypes.func,
  readOnly: PropTypes.bool,
  extraRight: PropTypes.node
};
BaseInput.defaultProps = {
  children: null,
  className: '',
  focused: false,
  placeholder: null,
  width: null,
  widthAdaptive: null,
  startIcon: null,
  endIcon: null,
  empty: false,
  size: null,
  onClear: function onClear() {},
  allowClear: false,
  right: null,
  disabled: false,
  bottom: null,
  innerButton: null,
  onClick: function onClick() {},
  readOnly: false,
  extraRight: null
};